import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import { FiMessageSquare } from "react-icons/fi";
import theme from "assets/theme";
import routes from "routes";
import { useSoftUIController, setOpenConfigurator } from "context";
import { DashboardProvider } from "context/DashboardContext";
import { AuthProvider, useAuth } from "context/AuthContext";
import { NotificationProvider } from "context/NotificationContext";
import { FinanceProvider } from "context/FinanceContext";
import AccessGuard from "protectedRoutes/AccessGuard";
import "styles/admin.css";

export default function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <DashboardProvider>
          <FinanceProvider>
            <InnerApp />
          </FinanceProvider>
        </DashboardProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}
function InnerApp() {
  const [controller, dispatch] = useSoftUIController();
  const { token } = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const getRoutes = (entries) =>
    entries.map((route) =>
      route.collapse ? (
        getRoutes(route.collapse)
      ) : route.route ? (
        <Route
          path={route.route}
          key={route.key}
          element={
            route.requiresAuth === false ? (
              route.component
            ) : (
              <AccessGuard resource={route.resource}>
                {route.component}
              </AccessGuard>
            )
          }
        />
      ) : null
    );
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {token &&
        controller.layout === "dashboard" &&
        !pathname.startsWith("/authentication/") && (
          <>
            <Sidenav routes={routes} />
            {controller.openConfigurator && <Configurator />}
            <button
              className="support-button"
              aria-label="Contact customer service"
              onClick={() =>
                setOpenConfigurator(dispatch, !controller.openConfigurator)
              }
            >
              <FiMessageSquare size={20} />
            </button>
          </>
        )}
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ThemeProvider>
  );
}
